import en from './accountsStrings.en';

export default {
  en,
};
